import Sentry from '@/services/sentry/Sentry';

type Data = Record<string, unknown>;

// Breadcrumbs record the creator's path so any error captured afterwards carries
// the full journey that led to it. Every Sentry call is guarded because telemetry
// must never throw and break the flow it is only meant to observe.

export function trackDeliverables(message: string, data?: Data) {
  try {
    Sentry.addBreadcrumb({
      type: 'info',
      category: 'deliverables',
      message,
      level: 'info',
      data,
    });
  } catch {
    // swallow — instrumentation is best-effort
  }
}

export function captureDeliverablesError(
  error: unknown,
  message: string,
  context?: Data
) {
  try {
    Sentry.addBreadcrumb({
      type: 'error',
      category: 'deliverables',
      message,
      level: 'error',
      data: context,
    });
    Sentry.captureException(
      error instanceof Error ? error : new Error(message),
      {
        deliverables: {message, ...context},
      }
    );
  } catch {
    // swallow — instrumentation is best-effort
  }
}
